export const LT_LIFESTYLE_EXPENSES_DATA_RECEIVED = 'LT_LIFESTYLE_EXPENSES_DATA_RECEIVED'
export const LT_LIFESTYLE_EXPENSES_DATA_FAILED = 'LT_LIFESTYLE_EXPENSES_DATA_FAILED'
export const LT_LIFESTYLE_EXPENSE_SAVED = 'LT_LIFESTYLE_EXPENSE_SAVED'
export const LT_LIFESTYLE_EXPENSE_SAVE_FAILED = 'LT_LIFESTYLE_EXPENSE_SAVE_FAILED'
export const LT_LIFESTYLE_EXPENSE_DELETED = 'LT_LIFESTYLE_EXPENSE_DELETED'
export const LT_LIFESTYLE_EXPENSE_RECEIVED = 'LT_LIFESTYLE_EXPENSE_RECEIVED'
export const LT_LIFESTYLE_EXPENSE_RECEIVE_FAILED = 'LT_LIFESTYLE_EXPENSE_RECEIVE_FAILED'
export const LT_LIFESTYLE_EXPENSE_UNLOADED = 'LT_LIFESTYLE_EXPENSE_UNLOADED'
